module.exports = __webpack_public_path__ + "static/media/icRemittanceMRR.5184811c.svg";